"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 鼠标事件管理器
 *
 * 处理鼠标事件队列，并补充额外事件。
 */
var MouseEventHandler = /** @class */ (function () {
    function MouseEventHandler(viewport) {
        var _this = this;
        this.viewport = viewport;
        this.beforeViewPortEvent = null;
        this.beforeHits = [];
        this.mousemoveHandler = function (e) {
            var e_1, _a, e_2, _b;
            var ctx = _this.viewport.engine.ctx;
            var _c = ctx.canvas, offsetTop = _c.offsetTop, offsetLeft = _c.offsetLeft;
            var vev = _this.viewport.transformEvent('move', [e.offsetX - offsetLeft, e.offsetY - offsetTop]);
            var hits = _this.viewport.engine.hitTest(vev.p);
            hits = hits.slice(0, 1); //只取一个  TODO 不确定这样的逻辑设计是否合理
            try {
                // 处理level
                for (var _d = __values(_this.beforeHits), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var hit = _e.value;
                    try { // 可能存在之前的hit已经被移除
                        var shape = _this.viewport.engine.getShape(hit);
                        if (!hits.includes(hit)) {
                            shape.onMouseLeave(vev);
                        }
                    }
                    catch (error) {
                        // 正常业务
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                // 处理enter和move
                for (var hits_1 = __values(hits), hits_1_1 = hits_1.next(); !hits_1_1.done; hits_1_1 = hits_1.next()) {
                    var hit = hits_1_1.value;
                    // 可能存在已经选的hit已经被移除
                    try {
                        var shape = _this.viewport.engine.getShape(hit);
                        if (!_this.beforeHits.includes(hit)) {
                            shape.onMouseEnter(vev);
                        }
                        else {
                            shape.onMouseMove(vev);
                        }
                    }
                    catch (error) {
                        // 正常业务
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (hits_1_1 && !hits_1_1.done && (_b = hits_1.return)) _b.call(hits_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            _this.beforeHits = hits;
            _this.beforeViewPortEvent = vev;
        };
    }
    MouseEventHandler.prototype.bind = function () {
        this.viewport.engine.ctx.canvas.addEventListener('mousemove', this.mousemoveHandler);
    };
    MouseEventHandler.prototype.unbind = function () {
        this.viewport.engine.ctx.canvas.removeEventListener('mousemove', this.mousemoveHandler);
    };
    return MouseEventHandler;
}());
exports.MouseEventHandler = MouseEventHandler;
//# sourceMappingURL=MouseEventHandler.js.map